import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class servicesActionsMenuCtrl implements IController {

  coordinationStatus: any;
  createDeliveries: Function;
  declineServices: Function;
  sendServicesTextMessage: Function;
  onOpen: Function;

  private isInactive: boolean;
  private disableButtons: any;

  /* @ngInject */
  constructor(private confirmDialogService: ConfirmDialogService, private $log) {
  }

  ///////////////////////////////////////////////////

  $onInit() {
    this.disableButtons = {
      sendSms: false,
      createDeliveries: false,
      declineAll: false
    };
    this.isInactive = _.isEqual(this.coordinationStatus, 'Inactive');
  };

  $onChanges(changes) {

    if (changes.coordinationStatus && !changes.coordinationStatus.isFirstChange()) {
      const currentCoordinationStatus = changes.coordinationStatus.currentValue,
        previousCoordinationStatus = changes.coordinationStatus.previousValue;

      if (_.isEqual(currentCoordinationStatus, previousCoordinationStatus)) {
        this.$onInit()
      }
    }
  };

  onOpenSelection($mdMenu, event) {
    this.onOpen((disableInit) => {
      this.disableButtons = disableInit;
      this.isInactive = _.isEqual(this.coordinationStatus, 'Inactive');
      $mdMenu.open(event);
    });
  }

  onSendServicesTextMessage(event) {
    const title = 'Send SMS',
      textContent = 'Are you sure you want to send SMS to these deliveries?';

    this.confirmDialogService.confirm(title, textContent, event)
      .then(() => {
        this.sendServicesTextMessage();
      })
      .finally(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onDeclineServices(event) {
    const title = 'Decline Services',
      textContent = 'Are you sure you want to decline these deliveries?';

    this.confirmDialogService.confirm(title, textContent, event)
      .then(() => {
        this.declineServices();
      })
      .finally(() => {
        this.$log.info('Dialog Closed')
      })
  }

}

angular
  .module('bringoz.admin.coordinations')
  .component('servicesActionsMenu', {
    bindings: {
      coordinationStatus: '<',
      createDeliveries: '&',
      declineServices: '&',
      sendServicesTextMessage: '&',
      onOpen: '='
    },
    template: require('./services-actions-menu.html').default,
    controller: servicesActionsMenuCtrl
  });
